<template>
    <div class="row-block" style="background-color: rgb(248, 248, 255);">
        <div class="container">
            <div class="column-inner">
                <div class="wrapper">
                    <div class="project-inner-container d-flex flex-row">
                        <div class="col-sm-8 col-display" style="padding: 0;">
                            <div class="column-inner">
                                <div class="wrapper">
                                    <div class="image-figure text-center">
                                        <a :href="project.web" target="_blank">
                                            <img :src="project.img" :alt="project.alt">
                                        </a>
                                    </div>
                                    <div v-if="yt" class="video-figure text-center">
                                        <iframe :src="project.ytVideo[2]" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4 col-display">
                            <div class="column-inner sticky-element">
                                <div class="wrapper">
                                    <div class="project-info" :style="{borderLeftColor: project.color}">
                                        <div class="info-header">
                                            <h3>{{project.title}}</h3>
                                        </div>
                                        <div class="spacer-lg"></div>
                                        <div class="info-body">
                                            <h5>{{dataText.projects.templateText[0]}}</h5>
                                            <p>{{project.client}}</p>
                                            <div class="spacer-md"></div>
                                            <div v-if="project.web !== '/'">
                                                <h5>{{dataText.projects.templateText[1]}}</h5>
                                                <a :href="project.web" target="_blank"><p>{{project.web}}</p></a>
                                                <div class="spacer-md"></div>
                                            </div>
                                            <div v-if="yt">
                                                <h5>{{dataText.projects.templateText[2]}}</h5>
                                                <a :href="project.ytVideo" target="_blank"><p>{{project.ytVideo[1]}}</p></a>
                                                <div class="spacer-md"></div>
                                            </div>
                                            <h5>{{dataText.projects.templateText[3]}}</h5>
                                            <p v-for="(item, index) in project.service" :key="index">{{item}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProjectInfo",
        props: {
            project: {
                id: String,
                title: String,
                client: String,
                web: String,
                service: Array,
                ytVideo: Array,
                img: String,
                alt: String,
                color: String,
                required: true
            }
        },
        data () {
            return {
                dataText: this.$store.state.HR.aboutUs,
                yt: false
            }
        },
        created() {
            console.log('p: ', this.project);
            this.yt = !!this.project.ytVideo[0];
        }
    }
</script>

<style scoped>
    .project-inner-container {
        padding-top: 80px;
        margin-left: -80px;
        margin-right: -80px;
    }
    .image-figure, .video-figure {
        display: block;
        width: 100%;
        margin-bottom: 20px;
        box-shadow: 0 0 30px -12px #222222;
    }
    .image-figure a img {
        width: 100%;
        height: auto;
    }
    .video-figure iframe {
        width: 100%;
        height: 550px;
    }
    .sticky-element {
        position: sticky;
        top: 25px;
    }
    .project-info {
        border-left-width: 8px;
        border-left-style: solid;
        border-radius: 5px;
        padding-top: 15px;
        padding-left: 10px;
    }
    .info-body p {
        margin-bottom: 0;
    }

</style>